import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import { BACKEND_URL } from '@/config';

export default function SplashPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(null);
  // Comptes de démo servis par le serveur, seulement en démonstration (SEED_DEMO) : en production la page n'existe pas,
  // et aucun mot de passe n'est écrit dans le code envoyé au navigateur
  const [personas, setPersonas] = React.useState(null);

  React.useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/demo-accounts`)
      .then(({ data }) => setPersonas(data.data || []))
      .catch(() => navigate('/', { replace: true }));
  }, [navigate]);

  React.useEffect(() => {
    if (user) {
      navigate(user.roles?.includes('ROLE_ADMIN') ? '/admin/dashboard' : '/app/dashboard');
    }
  }, [user, navigate]);

  const handlePersona = async (persona) => {
    // Admin : double authentification obligatoire, la connexion se fait sur sa page
    if (!persona.password) { navigate('/login'); return; }
    setLoading(persona.id);
    try {
      const data = await login(persona.email, persona.password);
      navigate(data.roles?.includes('ROLE_ADMIN') ? '/admin/dashboard' : '/app/dashboard');
    } catch (e) {
      console.error('Login error:', e);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="splash">
      <div className="splash-head">
        <div className="splash-logo">
          <div className="splash-logo-mark">2</div>
          <div>
            <div className="splash-logo-name">Colis<em>2</em>Ship</div>
            <div className="splash-logo-tag">Démo interactive — MVP v1.0</div>
          </div>
        </div>
        <div style={{ textAlign: 'right', fontSize: 12.5, color: 'rgba(255,255,255,.55)' }}>
          <div>Plateforme de covoiturage de colis</div>
          <div style={{ color: 'var(--ink3)', marginTop: 2 }}>Europe · Afrique · Amérique</div>
        </div>
      </div>

      <div className="splash-hero">
        <div className="splash-eyebrow">Démo complète tous profils</div>
        <h1 className="splash-title">
          Choisissez un profil<br />pour explorer <em>la plateforme</em>
        </h1>
        <p className="splash-sub">
          {personas ? `${personas.length} profils pré-configurés` : 'Profils pré-configurés'} — chaque parcours est entièrement navigable avec données réalistes. Vous pouvez vous connecter manuellement depuis la page de connexion.
        </p>
      </div>

      <div className="persona-grid">
        {(personas || []).map(p => (
          <button
            key={p.id}
            data-testid={`persona-${p.id}`}
            className="persona-card"
            onClick={() => handlePersona(p)}
            disabled={loading !== null}
          >
            <div className={`av lg ${p.color}`}>{p.initials}</div>
            <div className="p-name">{p.name}</div>
            <div className="p-role">{p.role}</div>
            <div className="p-desc">{p.desc}</div>
            <div className="p-badges">
              {p.badges.map(b => (
                <span key={b} className={`p-badge${b === 'PRO' ? ' pro' : b === 'Entreprise' ? ' entreprise' : b === 'ROLE_ADMIN' ? ' admin' : ''}`}>{b}</span>
              ))}
            </div>
            <div className="p-cta">
              {loading === p.id
                ? 'Connexion en cours...'
                : `Se connecter en tant que ${p.name.split(' ')[0]} →`}
            </div>
          </button>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <button
          data-testid="btn-manual-login"
          onClick={() => navigate('/login')}
          style={{
            background: 'rgba(255,255,255,.1)', color: '#fff', border: '1px solid rgba(255,255,255,.15)',
            borderRadius: 'var(--r)', padding: '10px 24px', cursor: 'pointer', fontSize: 14,
          }}
        >
          Se connecter manuellement
        </button>
      </div>

      <div className="splash-foot">
        Stack : React · FastAPI · MongoDB · Stripe Connect
        <em style={{ marginLeft: 8 }}> Confidentiel — usage interne</em>
      </div>
    </div>
  );
}
